<template>
    <div>
    	<div @click="methodClick" v-bind:id="'marker-' + ID" class="marker mark-pill" v-bind:style="'top:' + position.x + 'px;left:' + position.y + 'px; background:'+color+'; '">
	    	<div style="font-weight: bold;">{{label}}</div>
	    </div>
		<div v-bind:id="'desc-marker-' + ID" class="marker-description" v-bind:style="'border:1.5px solid ' + color + ';'">
			<button  onclick="this.parentElement.classList.remove('visible')">X</button>
			<div class="desc-title">{{description.title}}</div>
			<div class="desc-detail">{{description.detail}}</div>
		</div>
    </div>
</template>
<script>
export default {
    props: ["ID", "position", "label", "description", "color"],
    methods: {
    	methodClick(ec){
			var mid = ec.srcElement.parentElement.getAttribute("id");
			if(mid == null) mid = ec.srcElement.getAttribute("id");
			document.querySelectorAll(".marker-description").forEach(e => {e.classList.remove('visible')});
			document.querySelector('#desc-' + mid).classList.add('visible');
    	}
    }
}
</script>
<style scoped>
.marker{
	position:absolute;
	color:white;
	width: 27px;
	height: 27px;
	border-radius: 50%;
	border: 1px solid white;
	cursor: pointer;
}
	.mark-pill{
		height: 27px;
		width: auto;
		border-radius: 5px;
		padding: 0 15px;
	}
	.marker-description{
		position: absolute;
		width: 80%;
		height: 50%;
		background: #eee;
		top: 50%;
		left: 10%;
		overflow: auto;
		padding: 2%;
		border-radius: 2%;
		display: none;
		z-index: 1000;
	}
	.marker-description button{
		background: #601818;
		border-radius: 50%;
		width: 30px;
		height: 30px;
		color: white;
		font-weight: bold;
		position: absolute;
		top: 10px;
		right: 10px;
	}
	.visible{
		display: block;
	}
	.desc-title{
		font-weight: 1000;
		font-size: 1.5em;
	}
</style>